<template>
  <div>
    <ThreadsNav show-back :show-center="false">
      <template #right>
        <!-- <button class="btn btn-sm" @click="clickCache()">暂存</button> -->
        <button class="btn btn-primary btn-sm" @click="clickConfirm(1)">
          {{ $t("Buttons.send") }}
        </button>
      </template>
    </ThreadsNav>

    <div class="px-4">
      <div class="red-dot ml-5 flex justify-between items-center">
        <h3>{{ $t("treehole.currentSelf") }}</h3>
        <button class="btn btn-xs" @click="clickSelectSelf">
          {{ $t("Buttons.change") }}
        </button>
      </div>

      <div class="flex items-center justify-between mt-3 gap-2">
        <MateAvatarNameBioCard :mate="currentMate" class="flex-1" />
        <div>
          <button class="btn btn-xs" @click="clickEditMate">
            {{ $t("Buttons.edit") }}
          </button>
        </div>
      </div>
    </div>

    <div class="p-4">
      <VanField
        v-model="moment.text"
        :placeholder="t('treehole.placeholder')"
        type="textarea"
        autosize
        rows="5"
      ></VanField>
    </div>

    <!-- <div class="px-4">
      <div class="red-dot ml-5 flex justify-between items-center">
        <h3>对未连接的角色开放</h3>
        <van-switch v-model="moment.canUnlinkedAiInteract" size="16" />
      </div>
    </div> -->

    <MateTreeholeSelfSelect
      v-model:show="showSelfSelect"
      :active-mate="currentMate"
      @update:active-mate="updateActiveMate"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useMate } from "@/stores/mate";
import api, { PostMomentParams } from "@/modules/api";
import { MomentVisibility } from "@/types/collection";
import { Mate } from "@/types/entity";
import { showLoadingToast, showSuccessToast } from "vant";
import { useI18n } from "vue-i18n";
import { routerBack } from "@/use/go";
import { useMoment } from "@/stores/moment";
import { StorageGet, StorageRemove, StorageSet } from "@/tools/localStorage";

const { t } = useI18n();
const mateStore = useMate();
const router = useRouter();
const currentMate = ref<Mate>(mateStore.userMate);
const momentStore = useMoment();

const moment = ref<PostMomentParams>({
  mateId: currentMate.value.uuid,
  text: "",
});

watch(
  () => moment.value.text,
  () => {
    clickCache(false);
  },
  {
    deep: true,
  }
);

const clickConfirm = async (status: 1 | 2) => {
  const loading = showLoadingToast(
    t(`Message.${status === 1 ? "publishing" : "savingProgress"}`)
  );
  try {
    await api.createMoment({
      ...moment.value,
      visibility: MomentVisibility.SelfOnly,
      mateId: currentMate.value.uuid,
      status,
      type: 2,
    });
    await momentStore.initTreeholeMomentListIfEmpty();
    loading.close();

    StorageRemove("treeholeMoment");

    showSuccessToast({
      message: t(`Message.${status === 1 ? "publishSuccess" : "saveSuccess"}`),
      onClose: () => {
        if (status === 1) {
          routerBack();
        }
      },
    });
  } catch (error) {
    loading.close();
  }
};

const clickCache = (showToast = true) => {
  moment.value.mateId = currentMate.value.uuid;
  StorageSet("treeholeMoment", moment.value);
  if (showToast) {
    showSuccessToast(t("Message.saveSuccess"));
  }
};

const clickEditMate = () => {
  router.push({
    name: "treeholeSelfSetting",
    query: {
      mateUuid: currentMate.value.uuid,
    },
  });
};

const showSelfSelect = ref(false);

const clickSelectSelf = () => {
  showSelfSelect.value = true;
};

const updateActiveMate = async (mate: Mate) => {
  currentMate.value = mate;
  showSelfSelect.value = false;
  StorageSet("treeholeMomentActiveMate", mate.uuid);
};

onMounted(() => {
  let cache = StorageGet("treeholeMoment");
  if (cache) {
    moment.value = cache;
    currentMate.value = mateStore.mateMap.get(cache.mateId)!;
  }
  const activeMateUuid = StorageGet("treeholeMomentActiveMate");
  if (activeMateUuid) {
    const mate = mateStore.mateMap.get(activeMateUuid);
    if (mate) {
      currentMate.value = mate;
    }
  }
});
</script>
